import {Controller, useFormContext} from 'react-hook-form';
import {Field, FieldLabel} from '@/components/ui/field.tsx';
import React from 'react';
import type {Orientation} from '@/components/form/form.tsx';
import {MultiSelect} from '@/components/ui/multi-select.tsx';
import {uniqueId} from '@/lib/utils.ts';

type MultiSelectProps = React.ComponentProps<typeof MultiSelect>;

type MultiSelectFieldProps = {
  name: string;
  label?: string;
  options: MultiSelectProps['options'];
  className?: string;
  orientation?: Orientation;
  triggerClassName?: string;
} & Omit<MultiSelectProps, 'onValueChange'>;

export function MultiSelectField({
                                   name,
                                   label,
                                   className,
                                   orientation,
                                   options,
                                   triggerClassName,
                                   ...props
                                 }: MultiSelectFieldProps) {
  const {control} = useFormContext();
  const id = props?.id ?? uniqueId('input-field');
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Field data-invalid={fieldState.invalid} className={className} orientation={orientation}>
          {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
          {options.length > 0 && (
            <MultiSelect
              className={triggerClassName}
              options={options}
              value={field.value}
              defaultValue={field.value}
              onValueChange={field.onChange}
              singleLine={true}
              animationConfig={{
                badgeAnimation: 'none',
                popoverAnimation: 'none',
                optionHoverAnimation: 'none'
            }}
              {...props}
            />
          )}
        </Field>
      )}
    />
  );
}
